import { createActionCreator, createReducer } from 'helpers/redux/reduxHelpers';
import { AppState } from 'helpers/store/models/AppState';
import { combineReducers } from 'redux';

/* STATE */
export interface LastActivityState {
  activityTime: any;
}

/* ACTION TYPES */
export enum LastActivityActionTypes {
  UserWasActive = '@@Sample/USER_WAS_ACTIVE',
}

/* ACTIONS */
export const userActivityTimeAction = createActionCreator(LastActivityActionTypes.UserWasActive);

/* REDUCERS */
const initialState: LastActivityState = {
  activityTime: null,
};

const activityTime = createReducer(initialState.activityTime, {
  [LastActivityActionTypes.UserWasActive]: () => new Date(),
});

export default combineReducers<LastActivityState>({
  activityTime,
});

/* SELECTORS */
const selectLastActivity = (state: AppState) => {
  return state.lastUserActivity;
};

export const selectLastActivityTime = (state: AppState): any => selectLastActivity(state).activityTime;
